module.exports = __webpack_public_path__ + "static/img/获批省级研究生工作站.b95a3d16.jpg";